import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pt-xl pb-2xl pt-4xl@lg pb-6xl@lg text-center bg-neutral-850" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockTitle = _resolveComponent("BlockTitle")!
  const _component_ArticleCardSkeleton = _resolveComponent("ArticleCardSkeleton")!
  const _component_ArticleCard = _resolveComponent("ArticleCard")!
  const _component_ArticleBlock = _resolveComponent("ArticleBlock")!
  const _component_ButtonText = _resolveComponent("ButtonText")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ArticleBlock, null, {
      default: _withCtx(() => [
        _createVNode(_component_BlockTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trans("general.latest_news")), 1)
          ]),
          _: 1
        }),
        (_ctx.articlesWithMetadata[1].pending)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quantityLastArticles, (n) => {
                return (_openBlock(), _createBlock(_component_ArticleCardSkeleton, {
                  class: "d-none@md",
                  key: 'article-card-skeleton-' + n
                }))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quantityLastArticles, (n) => {
                return (_openBlock(), _createBlock(_component_ArticleCardSkeleton, {
                  class: "d-none d-block@md",
                  key: 'article-card-skeleton-in-two-rows-' + n,
                  isTwoColumns: ""
                }))
              }), 128))
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.articlesWithMetadata[1].pending)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestArticles, (article) => {
                return (_openBlock(), _createBlock(_component_ArticleCard, {
                  class: "d-none@md",
                  key: article._id,
                  article: article
                }, null, 8, ["article"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.latestArticles, (article) => {
                return (_openBlock(), _createBlock(_component_ArticleCard, {
                  class: "d-none d-block@md",
                  key: article._id,
                  article: article,
                  isTwoColumns: ""
                }, null, 8, ["article"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        to: { name: 'News' },
        style: {"text-decoration":"none"},
        color: "accent",
        isText: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ButtonText, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.trans("general.see_all_news")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ButtonIcon, { name: "chevron-right" })
        ]),
        _: 1
      })
    ])
  ]))
}